import { gql } from "@apollo/client"
export const USAGE_REPORT = gql`
    query usageReport($date: MonthYearInput) {
        whoAmI {
            company {
                users(withAccessOn: $date) {
                    id
                    email
                    loginCount(date: $date)
                    translatedAudioCount(date: $date)
                    generatedAudioCount(date: $date)
                    approvedAudioCount(date: $date)
                    uploadedAudioCount(date: $date)
                }
                maxOperations
                currentOperations(date: $date)
                maxStorage
                currentStorage
            }
        }
    }
`
